import { render, staticRenderFns } from "./DeleteMediaItemForm.vue?vue&type=template&id=675b2f96"
import script from "./DeleteMediaItemForm.vue?vue&type=script&lang=js"
export * from "./DeleteMediaItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports